<template>
  <layouts-header></layouts-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />
  <coach-settings-tabset></coach-settings-tabset>
  <div class="content court-bg">
    <div class="container">
      <settings-tabset></settings-tabset>

      <div class="row">
        <div class="col-sm-12">
          <div class="profile-detail-blk">
            <ul>
              <li>
                <router-link to="/coaches/coach-profile">Profile Details </router-link>
              </li>
              <li>
                <router-link to="/coaches/appointment-details"
                  >Appointment Details</router-link
                >
              </li>
            </ul>
          </div>
          <div class="profile-detail-group">
            <div class="card">
              <form>
                <div class="row">
                  <div class="appoint-head">
                    <h4>Amount</h4>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="input-space link-apoint">
                      <label class="form-label">Select Currency type</label>
                      <vue-select :options="USDType" id="usdtype" placeholder="USD" />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="input-space link-apoint">
                      <label class="form-label">For Onetime Appointment (USD)</label>
                      <input
                        type="text"
                        class="form-control"
                        id="email"
                        placeholder="Enter Amount"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="appoint-head coach-top">
                      <h4>Your Coaching Images</h4>
                    </div>
                    <div class="file-upload-text appointment-upload">
                      <div class="file-upload">
                        <img
                          src="@/assets/img/icons/upload-icon.svg"
                          class="img-fluid"
                          alt="Upload"
                        />
                        <p>Upload Coaching Gallery</p>
                        <input type="file" id="file-input" />
                      </div>
                      <div class="upload-show-img">
                        <div class="upload-images" v-if="isVisible">
                          <img src="@/assets/img/booking/booking-01.jpg" alt="Uploader" />
                          <a
                            href="javascript:void(0);"
                            @click="hideProduct"
                            class="btn btn-icon logo-hide-btn btn-sm"
                            ><i class="far fa-trash-alt"></i
                          ></a>
                        </div>
                        <div class="upload-images" v-if="isVisible2">
                          <img src="@/assets/img/booking/booking-02.jpg" alt="Uploader" />
                          <a
                            href="javascript:void(0);"
                            @click="hideProduct2"
                            class="btn btn-icon logo-hide-btn btn-sm"
                            ><i class="far fa-trash-alt"></i
                          ></a>
                        </div>
                        <div class="upload-images" v-if="isVisible3">
                          <img src="@/assets/img/booking/booking-03.jpg" alt="Uploader" />
                          <a
                            href="javascript:void(0);"
                            @click="hideProduct3"
                            class="btn btn-icon logo-hide-btn btn-sm"
                            ><i class="far fa-trash-alt"></i
                          ></a>
                        </div>
                      </div>
                      <h5>
                        Image Should be minimum 152 * 152 Supported File format
                        JPG,PNG,SVG
                      </h5>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="appoint-head">
                      <h4>Video</h4>
                    </div>
                    <div class="input-space link-apoint">
                      <label class="form-label"> Link</label>
                      <div class="input-box">
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          placeholder="Enter Video Link"
                        />
                        <p>Video Supported File format MP4 Format</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="appoint-head">
                      <h4>Short Bio</h4>
                    </div>
                    <div class="info-about">
                      <label class="form-label">Enter Bio</label>
                      <textarea
                        class="form-control"
                        rows="3"
                        placeholder="Enter Bio"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="appoint-head">
                      <h4>Lesson With Me</h4>
                    </div>
                    <div class="info-about">
                      <label class="form-label">Enter Content</label>
                      <textarea
                        class="form-control"
                        rows="3"
                        placeholder="Enter Content"
                      ></textarea>
                      <div class="check-single-lesson">
                        <div class="similar-player">
                          <div class="form-check d-flex align-items-center policy">
                            <div class="d-inline-block">
                              <input class="form-check-input" type="checkbox" value="" />
                            </div>
                            <label class="form-check-label">Single Lesson</label>
                          </div>
                          <ul>
                            <li>3 Days * 1 hour @ <span>$150.00</span></li>
                          </ul>
                        </div>
                        <div class="similar-player">
                          <div class="form-check d-flex align-items-center policy">
                            <div class="d-inline-block">
                              <input class="form-check-input" type="checkbox" value="" />
                            </div>
                            <label class="form-check-label">2 Player Lesson</label>
                          </div>
                          <ul>
                            <li>3 Days * 1 hour @ <span>$150.00</span></li>
                            <li>*4 players of similar age and ability</li>
                          </ul>
                        </div>
                        <div class="similar-player">
                          <div class="form-check d-flex align-items-center policy">
                            <div class="d-inline-block">
                              <input class="form-check-input" type="checkbox" value="" />
                            </div>
                            <label class="form-check-label">Small Group Lesson</label>
                          </div>
                          <ul>
                            <li>2 Days * 1 hour @ <span>$200.00</span></li>
                            <li>*4 players of similar age and ability</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="appoint-head">
                      <h4>Coaching</h4>
                    </div>
                    <div class="info-about p-0 m-0 border-bottom-0">
                      <label class="form-label">Enter Bio</label>
                      <textarea
                        class="form-control"
                        rows="3"
                        placeholder="Enter Bio"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="save-changes text-end">
              <a href="javascript:;" class="btn btn-primary reset-profile">Reset</a>
              <a href="javascript:;" class="btn btn-secondary save-profile"
                >Save Change</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
export default {
  data() {
    return {
      USDType: ["USD", "Euro"],
      title: "Profile Setting",
      text: "Home",
      text1: "Profile Setting",
      isVisible: true,
      isVisible2: true,
      isVisible3: true,
    };
  },
  methods: {
    hideProduct() {
      this.isVisible = false;
    },
    hideProduct2() {
      this.isVisible2 = false;
    },
    hideProduct3() {
      this.isVisible3 = false;
    },
  },
};
</script>
